import { FC } from 'react';
import {
  HeadSection,
  OurMissionSection,
  OurValuesSection,
  WeArePowerleadSection,
} from './components';
import { ExtensionPromoSection } from '@/components';

export const About: FC = () => {
  return (
    <>
      <HeadSection />
      <OurMissionSection />
      <OurValuesSection />
      <WeArePowerleadSection />
      <ExtensionPromoSection />
    </>
  );
};
